import React from 'react';
import './BtnArticleModal.scss';
import { handleRequest } from '@/utils';
import ModalConfirm from '@/components/Modal/confirm';
import UIModal from './UIModal';
import { inject, observer } from 'mobx-react';
import { ModalStoreType } from '@/types/store/modal';
import { SessionStoreType } from '@/types/store/session';
import sanitizeHtml from 'sanitize-html';
import sanitizeHtmlOptions from '@/utils/sanitizeHtmlOptions';
import { getChildInject } from '@/utils/instantLoaded/tools';
import { ChatbotUIBasicProps } from '@/types/common';

type BtnModalFuncProps = {
  modalStore: ModalStoreType;
  sessionStore: SessionStoreType;
} & {
  id: string;
  index: number;
  should_disappear: boolean;
  article: {
    contentid: string;
    title: string;
    url_name: string;
    article_number: string;
  };
  yes_callback: {
    should_disappear: boolean;
  };
  no_callback: {
    should_disappear: boolean;
  };
  pop_up_content: {
    read_more: string;
    confirm_value: string;
    content: string;
    refuse_value: string;
    title: string;
  };
  onClose?(): void;
  trackingArticleDetailBasicData: {
    chat_session_id: string;
    chat_dialogue_id: string;
    bot_id: number;
    intent_id: number;
    article_id: number;
    article_title: string;
  };
  customCallback?: ChatbotUIBasicProps['customCallback'];
}

export default function BtnModal(props: BtnModalFuncProps) {
  const {
    id,
    index,
    article,
    yes_callback,
    no_callback,
    pop_up_content: {
      read_more,
      confirm_value,
      content,
      refuse_value,
      title,
    },
    should_disappear,
    onClose,
    modalStore,
    sessionStore,
    trackingArticleDetailBasicData,
    customCallback = {},
  } = props;

  const Content = (
    <div className="content">
      <div>
        <span
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(content, sanitizeHtmlOptions) }}
        ></span>
        <span
          className="read-more"
          onClick={() => {
            modalStore.UPDATE_MODAL_ARTICLE({
              trackingArticleDetailBasicData,
              ...article,
            });
            modalStore.SHOW_ARTICLE_MODAL();
          }}
        >
          <span>{read_more}</span>
        </span>
      </div>
    </div>
  );

  return (<>
    <UIModal
      className="general-reply-type-btn-modal"
      title={title}
      content={Content}
      footer={[{ value: refuse_value }, {
        value: confirm_value,
        type: 'primary',
      }]}
      onMaskClick={onClose}
      onFooterClick={async (selectItem) => {
        onClose?.();

        const callback = {
          [confirm_value]: yes_callback,
          [refuse_value]: no_callback,
        }[selectItem.value];

        if (!callback) {
          return;
        }
        const res = await handleRequest('postMessage', {...callback, ...customCallback});

        // 请求异常不触发隐藏
        if (!res) {
          return;
        }

        if (callback?.should_disappear || should_disappear) {
          sessionStore.updateGeneralBtn({
            obj: { isBtnDisabled: true },
            messageId: id,
            optionIndex: index,
          });
        }
      }}
    />
  </>
  );
}

const StateBtnModal = inject(getChildInject('modalStore', 'sessionStore'))(observer(BtnModal));

export function confirm(props: BtnModalFuncProps) {
  // eslint-disable-next-line
  let modalInstance: ReturnType<typeof ModalConfirm>;

  const mergeProps = {
    ...props,
    onClose() {
      modalInstance.destroy();
    },
  };
  // open modal
  modalInstance = ModalConfirm({ children: <StateBtnModal {...mergeProps} /> });
}
